import React, { useEffect } from 'react';
import { WarehouseDetails } from './common.types';

export default function WarehouseVendorBHODirectShipQty(prop: any) {
  const { fromPage, warehouseStockDetail } = prop;
  localStorage.removeItem('vendorBohQuantity');
  useEffect(() => {
    if (
      (fromPage === 'product' || fromPage === 'productdetails') &&
      warehouseStockDetail?.warehouseDetails?.find(
        (item: WarehouseDetails) => item?.name === 'VENDOR WAREHOUSE**'
      )
    ) {
      const vendorBohQuantity =
        warehouseStockDetail?.warehouseDetails !== null &&
        warehouseStockDetail?.warehouseDetails !== undefined &&
        warehouseStockDetail?.warehouseDetails?.find(
          (item: WarehouseDetails) => item?.name === 'VENDOR WAREHOUSE**'
        )?.quantityAvailable;

      localStorage.setItem(
        'vendorBohQuantity',
        JSON.stringify(vendorBohQuantity)
      );
    } else if (
      fromPage === 'cart' &&
      warehouseStockDetail?.find(
        (item: any) => item?.warehouseDescription === 'VENDOR WAREHOUSE**'
      )
    ) {
      const vendorBohQuantity =
        warehouseStockDetail !== null &&
        warehouseStockDetail !== undefined &&
        warehouseStockDetail.find(
          (item: any) => item?.warehouseDescription === 'VENDOR WAREHOUSE**'
        )?.quantity;

      localStorage.setItem(
        'vendorBohQuantity',
        JSON.stringify(vendorBohQuantity)
      );
    }
  }, [fromPage, warehouseStockDetail]);

  return <></>;
}
